export const FilesSidebarList = {
  extends: 'FilesSectionList',
  childExtends: 'FilesSidebarListItem',
  children: async (el, s) => {
    const FilesSidebar = el.getFilesSidebar()
    const sorted = el.call('getCookie', `sidebar_${s.type}_sort`) === 'true'
    const list = await el.call('listSidebar', s.type, {
      search: FilesSidebar?.state?.search,
      activeFileSidebar: FilesSidebar?.state?.activeFileSidebar,
      sortIf:
        sorted &&
        ['components', 'pages', 'files', 'state', 'functions', 'methods'].includes(s.type),
      sort: (a, b) => {
        return a.key?.toLowerCase() < b.key?.toLowerCase() ? -1 : 1
      }
    })

    // Drop the layer-visibility entries of artboards that no longer exist.
    // `showLayersSchema` is ONE flat map keyed by item key and shared by the
    // pages and the components sections, while `list` is only what THIS
    // section renders — `listSidebar` filters pages/components to the current
    // canvas page and to the search string — so the stale test runs against
    // the artboard DATA over every artboard type, never against one section's
    // rendered list: the old `!list.find(...)` test deleted every other
    // section's entries and every entry off the current page on each render
    // (WS-FILES-SAVE-LAYERS-VISIBILITY-STATE-MISSING-1). The per-type
    // containers, not `getItem`: its cross-type fallback throws on a missing
    // container and counts a same-named non-artboard item as an owner.
    const showLayersSchema = el.scope.showLayersSchema
    if (list.length > 0 && showLayersSchema !== undefined && el.call('hasArtboard', s.type)) {
      const artboardTypes = el.call('getTypes', 'ARTBOARD_TYPES')
      const owned = (key) =>
        artboardTypes.some((type) => el.getData(type)?.[key] || el.getSchema(type)?.[key])
      let pruned = false
      Object.keys(showLayersSchema).forEach((key) => {
        if (owned(key)) return
        delete showLayersSchema[key]
        pruned = true
      })

      if (pruned) {
        el.syncCanvas({
          showLayersSchema
        })
      }
    }

    return list
  },
  onMouseleave: (ev, el) => {
    if (!el.getUserSettings('allowFilesidebarPreview')) {
      return
    }
    el.call('setScenePosition', null, {
      visible: false
    })
  },
  // Delegated right-click handler — some sections (#2061) override
  // `childExtends` to a custom row component (IconTemplateRow,
  // ColorTemplateRow, …) and rely on the v3.14 auto-extend chain to pull
  // in `FilesSidebarListItem.onContextmenu`. When the chain breaks (e.g.
  // a custom row stops chaining FilesSidebarListItem, or `childrenAs`
  // strips lifecycle hooks from the synthesized child def), the row's
  // own `onContextmenu` is silently absent and right-click is a no-op.
  // This handler resolves the right-clicked child from the DOM, locates
  // the matching DOMQL element, and forwards to the same
  // `activateContext(ev, child)` flow that `FilesSidebarListItem` runs —
  // guarantees a working context menu for every section regardless of
  // its child extends chain.
  onContextmenu: (ev, el) => {
    if (!ev?.target?.closest) return
    const root = el.node
    if (!root) return
    let cursor = ev.target
    let row = null
    while (cursor && cursor !== root) {
      if (cursor.parentNode === root) {
        row = cursor
        break
      }
      cursor = cursor.parentNode
    }
    if (!row) return
    // Find the matching DOMQL child by node identity. Children are keyed
    // off the rendered item state (s.key) so we walk the parent's
    // resolved children rather than rely on a DOM-side data attribute.
    const ref = el.__ref
    if (!ref?.__children) return
    let child = null
    for (const k of ref.__children) {
      const cand = el[k]
      if (cand?.node === row) {
        child = cand
        break
      }
    }
    if (!child || child.state?.editing) return
    const key = child.state?.key
    if (key && key !== el.getHoveredKey?.()) {
      el.activateHovered?.(key)
    }
    const t = setTimeout(() => {
      el.activateContext(ev, child)
      clearTimeout(t)
    }, 0)
  },
  align: 'stretch',
  flow: 'column',
  fontSize: 'Z2',
  gap: 'X1'
}
